import { defineComponent as _defineComponent } from 'vue';
import { createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/about/EQ1.png';
import _imports_1 from '@/assets/about/EQ2.png';
import _imports_2 from '@/assets/about/EQ3.png';
import _imports_3 from '@/assets/about/EQ4.png';
import _imports_4 from '@/assets/about/EQ5.png';
const _withScopeId = n => (_pushScopeId("data-v-a2f2ba64"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "qualifications"
};
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h3 class=\"title\" data-v-a2f2ba64>企业资质</h3><div class=\"main\" data-v-a2f2ba64><div class=\"qualifications_line qualifications_item\" data-v-a2f2ba64><div class=\"qualifications_list\" data-v-a2f2ba64><img src=\"" + _imports_0 + "\" alt=\"\" data-v-a2f2ba64></div></div><div class=\"qualifications_line\" data-v-a2f2ba64><div class=\"qualifications_list\" data-v-a2f2ba64><img src=\"" + _imports_1 + "\" alt=\"\" data-v-a2f2ba64><p data-v-a2f2ba64>深圳市卫星物联网产业协会</p><p data-v-a2f2ba64>副会长单位</p></div><div class=\"qualifications_list\" data-v-a2f2ba64><img src=\"" + _imports_2 + "\" alt=\"\" data-v-a2f2ba64><p data-v-a2f2ba64>深圳市航空航天产业协会</p><p data-v-a2f2ba64>副会长单位</p></div></div><div class=\"qualifications_line\" data-v-a2f2ba64><div class=\"qualifications_list\" data-v-a2f2ba64><img src=\"" + _imports_3 + "\" alt=\"\" data-v-a2f2ba64><p data-v-a2f2ba64>创新型中小企业</p></div><div class=\"qualifications_list\" data-v-a2f2ba64><img src=\"" + _imports_4 + "\" alt=\"\" data-v-a2f2ba64><p data-v-a2f2ba64>软著证书</p></div></div></div>", 2);
const _hoisted_4 = [_hoisted_2];
import eq1 from '@/assets/about/EQ1.png';
import eq2 from '@/assets/about/EQ2.png';
export default /*#__PURE__*/_defineComponent({
  __name: 'qualifications',
  setup(__props) {
    const qualificationsList = [{
      key: '1',
      img: eq1
    }, {
      key: '2',
      img: eq2
    }];
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_4);
    };
  }
});